import { useMutation } from '@tanstack/react-query';

import * as partnerApi from '@/apis/partner';
import type { NoDataResponse, PathVariableRequestParams } from '@/types/api';
import type { CommonUseMutationOptions } from '@/types/app';
import type { OrderProductParams, OrderProductResponse } from '@/types/partner';

export const useOrderProduct = (
  options?: CommonUseMutationOptions<OrderProductParams, OrderProductResponse>
) => {
  const mutation = useMutation({
    mutationFn: (params) => partnerApi.orderProduct(params),
    ...options,
  });

  return mutation;
};

export const useCancelOrderProdct = (
  options?: CommonUseMutationOptions<PathVariableRequestParams, NoDataResponse>
) => {
  const mutation = useMutation({
    mutationFn: (params) => partnerApi.cancelProductOrder(params),
    ...options,
  });

  return mutation;
};
